"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onCookieConsent = exports.emitCookieConsent = exports.hasStoredCookieConsentSettings = exports.hasCookieConsent = exports.getConsentSettings = exports.storeCookieConsentSettings = void 0;
const tslib_1 = require("tslib");
const __1 = require("..");
const types_1 = require("./types");
tslib_1.__exportStar(require("./types"), exports);
const CONSENT_COOKIE_KEY = 'acci_cookie_consent';
const CONSENT_COOKIE_EXPIRATION_IN_DAYS = 365; // consent must be renewed after 12 months
const CATEGORY_SEPARATOR = '.';
const COOKIE_CATEGORIES_BY_SHORT_KEY = {
    es: types_1.COOKIE_CATEGORIES.essential,
    pe: types_1.COOKIE_CATEGORIES.performance,
    an: types_1.COOKIE_CATEGORIES.analytics,
    ad: types_1.COOKIE_CATEGORIES.advertising,
};
const SHORT_KEYS_BY_COOKIE_CATEGORY = {
    [types_1.COOKIE_CATEGORIES.essential]: 'es',
    [types_1.COOKIE_CATEGORIES.performance]: 'pe',
    [types_1.COOKIE_CATEGORIES.analytics]: 'an',
    [types_1.COOKIE_CATEGORIES.advertising]: 'ad',
};
let consentSettings = typeof window !== 'undefined' ? getConsentSettingsFromCookie() : [];
function storeCookieConsentSettings(categories) {
    const value = categories.map(c => SHORT_KEYS_BY_COOKIE_CATEGORY[c]).join(CATEGORY_SEPARATOR);
    (0, __1.setDocumentCookie)({
        key: CONSENT_COOKIE_KEY,
        value,
        daysBeforeExpiration: CONSENT_COOKIE_EXPIRATION_IN_DAYS,
    });
    consentSettings = categories;
    emitCookieConsent(categories);
}
exports.storeCookieConsentSettings = storeCookieConsentSettings;
function getConsentSettings() {
    return consentSettings;
}
exports.getConsentSettings = getConsentSettings;
function getConsentSettingsFromCookie() {
    return (0, __1.getDocumentCookie)(CONSENT_COOKIE_KEY)
        .split(CATEGORY_SEPARATOR)
        .map(key => COOKIE_CATEGORIES_BY_SHORT_KEY[key])
        .filter(v => v);
}
function hasCookieConsent(category) {
    return category === types_1.COOKIE_CATEGORIES.essential ? true : consentSettings.includes(category);
}
exports.hasCookieConsent = hasCookieConsent;
function hasStoredCookieConsentSettings() {
    return consentSettings.length > 0;
}
exports.hasStoredCookieConsentSettings = hasStoredCookieConsentSettings;
function emitCookieConsent(categories) {
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('cookie-consent', {
            detail: { categories },
        }));
    }
}
exports.emitCookieConsent = emitCookieConsent;
function onCookieConsent(callback) {
    if (typeof window === 'undefined')
        return;
    if (consentSettings.length)
        callback(consentSettings);
    window.addEventListener('cookie-consent', ({ detail }) => {
        callback(detail.categories);
    });
}
exports.onCookieConsent = onCookieConsent;
//# sourceMappingURL=index.js.map